import * as Sentry from '@sentry/react';

export enum SentryTags {
    DocbaseVersion = 'docbase_version',
    HublApiVersion = 'hubl_api_version',
    HublReactVersion = 'hubl_react_version',
    TenantId = 'tenant_id',
    TenantName = 'tenant_name',
    Erp = 'erp',
    ReplayInvokedBy = 'replay_invoked_by',
    SSOEmailAddress = 'sso_email_address',
}

interface SentryUser {
    id?: string;
    email?: string;
    username?: string;
}

const setSentryUser = (user: SentryUser | null) => {
    Sentry.setUser(user);
};

const setSentryTag = (key: SentryTags | string, value: number | string | boolean | bigint | symbol | null | undefined) => {
    Sentry.setTag(key, value);
};

const useSentry = () => {
    const replay = Sentry.getReplay();

    const startSentryReplay = async () => {
        await replay?.flush();
        setSentryTag(SentryTags.ReplayInvokedBy, 'hubl_trace_shell');
        replay?.start();
    };

    const stopSentryReplay = async () => {
        await replay?.stop();
        setSentryTag(SentryTags.ReplayInvokedBy, null);
        replay?.startBuffering();
    };

    return {
        setSentryUser,
        setSentryTag,
        startSentryReplay,
        stopSentryReplay,
    };
};

export default useSentry;
